export abstract class ConcentrationCalculator {
  protected constructor() {}

  concentrationDuringInfusion(
    _startConcentration: number,
    _dosePerHr: number,
    _infusionInHrs: number,
    _timeDelta: number,
  ): number {
    console.error('Abstract version should not be called');
    return 0;
  }

  concentrationDuringDecay(
    _startConcentration: number,
    _decayInHrs: number,
    _timeDelta: number,
  ): number {
    console.error('Abstract version should not be called');
    return 0;
  }

  calculatePeak(
    _intervalInHrs: number,
    _infusionInHrs: number,
    _dosePerHr: number,
    _startTimeDelta = 0,
  ): number {
    console.error('Abstract version should not be called');
    return 0;
  }

  calculateTrough(
    _intervalInHrs: number,
    _infusionInHrs: number,
    _dosePerHr: number,
    _startTimeDelta = 0,
  ): number {
    console.error('Abstract version should not be called');
    return 0;
  }

  calculateTmic(
    intervalInHrs: number,
    infusionInHrs: number,
    dosePerHr: number,
    mic: number | null | undefined,
  ): number | null {
    return this.calculatTmicFromPeak(
      this.calculatePeak(intervalInHrs, infusionInHrs, dosePerHr),
      intervalInHrs,
      infusionInHrs,
      mic,
    );
  }

  calculatTmicFromPeak(
    _peak: number,
    _intervalInHrs: number,
    _infusionInHrs: number,
    _mic: number | null | undefined,
  ): number | null {
    console.error('Abstract version should not be called');
    return 0;
  }

  calculateAucFromPeakAndTrough(
    peak: number,
    trough: number,
    intervalInHrs: number,
    infusionInHrs: number,
    mic: number | null | undefined,
  ): number {
    const linear_area = infusionInHrs * ((trough + peak) / 2);
    const decay_area =
      peak === trough
        ? 0
        : ((peak - trough) / (Math.log(peak) - Math.log(trough))) * (intervalInHrs - infusionInHrs);
    const auc_0_tau = linear_area + decay_area;
    const auc_0_24 = (auc_0_tau * 24) / intervalInHrs;
    return mic ? auc_0_24 / mic : auc_0_24;
  }

  calculateAuc(
    intervalInHrs: number,
    infusionInHrs: number,
    dosePerHr: number,
    mic: number,
  ): number {
    const peak = this.calculatePeak(intervalInHrs, infusionInHrs, dosePerHr);
    const trough = this.calculateTrough(intervalInHrs, infusionInHrs, dosePerHr);
    return this.calculateAucFromPeakAndTrough(peak, trough, intervalInHrs, infusionInHrs, mic);
  }

  calculateSteadyState(_dose: number, _intervalInHrs: number, _infusionInHrs: number): number {
    console.error('Abstract version should not be called');
    return 0;
  }
}
